export const isFocusElement = (elem: Element | null): boolean => {
  if (elem === null) {
    return false;
  }

  return elem === document.activeElement;
};
